// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"88":"1b2ebcdb5c0e752c","335":"006905b3c24f8e98","531":"7697fd1bc6c83990","822":"c2e416f67c4db16f"}[chunkId] + ".js";
};